export const setSelectedMenu = id => ({ type: "N/SET_SELECTED_MENU", id });
export const setNote = note => ({ type: "N/SET_NOTE", note });
